<neo-list data="vm.data"></neo-list>
